import { render, staticRenderFns } from "./GoodSort.vue?vue&type=template&id=2e76215c&scoped=true"
import script from "./GoodSort.vue?vue&type=script&lang=js"
export * from "./GoodSort.vue?vue&type=script&lang=js"
import style0 from "./GoodSort.vue?vue&type=style&index=0&id=2e76215c&prod&lang=scss&scoped=true"
import style1 from "./GoodSort.vue?vue&type=style&index=1&id=2e76215c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e76215c",
  null
  
)

export default component.exports